const albums = {
  indexName: 'Albums',
  editName: 'AlbumEdit',
  accessRights: {
    deletePermissionsIds: [179, 180],
    updatePermissionsIds: [177, 178],
    createPermissionsIds: [175],
  },
};
const articles = {
  indexName: 'ArticleList',
  editName: 'ArticleEdit',
  accessRights: {
    deletePermissionsIds: [108, 109],
    updatePermissionsIds: [106, 107],
    createPermissionsIds: [104],
  },
};
const audio = {
  indexName: 'AudioList',
  editName: 'AudioEdit',
  accessRights: {
    deletePermissionsIds: [185, 186],
    updatePermissionsIds: [183, 184],
    createPermissionsIds: [181],
  },
};
const correspondence = {
  indexName: 'CorrespondenceList',
  editName: 'CorrespondenceEdit',
  accessRights: {
    deletePermissionsIds: [124, 125],
    updatePermissionsIds: [122, 123],
    createPermissionsIds: [120],
  },
};
const documentFiles = {
  indexName: 'DocumentFilesList',
  editName: 'DocumentFilesEdit',
  accessRights: {
    deletePermissionsIds: [197, 198],
    updatePermissionsIds: [195, 196],
    createPermissionsIds: [193],
  },
};
const documents = {
  indexName: 'Documents',
  editName: 'DocumentEdit',
  accessRights: {
    deletePermissionsIds: [191, 192],
    updatePermissionsIds: [189, 190],
    createPermissionsIds: [187],
  },
};
const events = {
  indexName: 'Events',
  editName: 'EventEdit',
  accessRights: {
    deletePermissionsIds: [130, 131],
    updatePermissionsIds: [129, 130],
    createPermissionsIds: [127],
  },
};
const faq = {
  indexName: 'FaqList',
  editName: 'FaqEdit',
  accessRights: {
    deletePermissionsIds: [136, 137],
    updatePermissionsIds: [134, 135],
    createPermissionsIds: [132],
  },
};
const gallery = {
  indexName: 'Gallery',
  editName: 'GalleryEdit',
  accessRights: {
    deletePermissionsIds: [155, 156],
    updatePermissionsIds: [153, 154],
    createPermissionsIds: [151],
  },
};
const images = {
  indexName: 'Images',
  editName: 'ImageEdit',
  accessRights: {
    deletePermissionsIds: [161, 162],
    updatePermissionsIds: [159, 160],
    createPermissionsIds: [157],
  },
};
const issuesAndAnswers = {
  indexName: 'IssuesAndAnswersList',
  editName: 'IssuesAndAnswersEdit',
  accessRights: {
    deletePermissionsIds: [228, 229],
    updatePermissionsIds: [226, 227],
    createPermissionsIds: [224],
  },
};
const lessons = {
  indexName: 'Lessons',
  editName: 'LessonEdit',
  accessRights: {
    deletePermissionsIds: [143, 144],
    updatePermissionsIds: [141, 142],
    createPermissionsIds: [139],
  },
};
const letterbooks = {
  indexName: 'Letterbooks',
  editName: 'LetterbookEdit',
  accessRights: {
    deletePermissionsIds: [114, 115],
    updatePermissionsIds: [112, 113],
    createPermissionsIds: [110],
  },
};
const locations = {
  indexName: 'Locations',
  editName: 'LocationEdit',
  accessRights: {
    deletePermissionsIds: [149, 150],
    updatePermissionsIds: [147, 148],
    createPermissionsIds: [145],
  },
};
const news = {
  indexName: 'News',
  editName: 'NewsEdit',
  accessRights: {
    deletePermissionsIds: [203, 204],
    updatePermissionsIds: [201, 202],
    createPermissionsIds: [199],
  },
};
const pamphlets = {
  indexName: 'PamphletList',
  editName: 'PamphletEdit',
  accessRights: {
    deletePermissionsIds: [209, 210],
    updatePermissionsIds: [207, 208],
    createPermissionsIds: [205],
  },
};
const people = {
  indexName: 'People',
  editName: 'PersonEdit',
  accessRights: {
    deletePermissionsIds: [215, 216],
    updatePermissionsIds: [213, 214],
    createPermissionsIds: [211],
  },
};
const publication = {
  indexName: 'Publications',
  editName: 'PublicationEdit',
  accessRights: {
    deletePermissionsIds: [222, 223],
    updatePermissionsIds: [220, 221],
    createPermissionsIds: [218],
  },
};
const qa = {
  indexName: 'QaList',
  editName: 'QaEdit',
  accessRights: {
    deletePermissionsIds: [228, 229],
    updatePermissionsIds: [226, 227],
    createPermissionsIds: [224],
  },
};
const topics = {
  indexName: 'Topics',
  editName: 'TopicEdit',
  accessRights: {
    deletePermissionsIds: [246, 247],
    updatePermissionsIds: [244, 245],
    createPermissionsIds: [242],
  },
};
const video = {
  indexName: 'VideoList',
  editName: 'VideoEdit',
  accessRights: {
    deletePermissionsIds: [173, 174],
    updatePermissionsIds: [171, 172],
    createPermissionsIds: [169],
  },
};
const videoSeries = {
  indexName: 'VideoSeriesList',
  editName: 'VideoSeriesEdit',
  accessRights: {
    deletePermissionsIds: [167, 168],
    updatePermissionsIds: [165, 166],
    createPermissionsIds: [163],
  },
};
const puzzleGame = {
  indexName: 'PuzzleImageIndex',
  editName: 'PuzzleImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254],
  },
};
const memoryGame = {
  indexName: 'MemoryImageList',
  editName: 'MemoryImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254],
  },
};
const paintingGame = {
  indexName: 'PaintingImageList',
  editName: 'PaintingImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254],
  },
};
const quizGame = {
  indexName: 'QuizImageList',
  editName: 'QuizImageEdit',
  accessRights: {
    deletePermissionsIds: [254],
    updatePermissionsIds: [254],
    createPermissionsIds: [254],
  },
};
const editorsPicks = {
  indexName: '',
  editName: '',
  accessRights: {
    deletePermissionsIds: [255],
    updatePermissionsIds: [255],
    createPermissionsIds: [255],
  },
};
const rightsArray = [
  albums,
  articles,
  audio,
  correspondence,
  documentFiles,
  documents,
  events,
  faq,
  gallery,
  images,
  issuesAndAnswers,
  lessons,
  letterbooks,
  locations,
  news,
  pamphlets,
  people,
  publication,
  qa,
  topics,
  video,
  videoSeries,
  puzzleGame,
  memoryGame,
  quizGame,
  paintingGame,
  editorsPicks,
];
export function getRightsByIndexName(indexName) {
  const rights = rightsArray.find(item => item.indexName === indexName);
  if (!rights) {
    return {};
  }
  return rights.accessRights;
}
export function getRightsByEditName(editName) {
  const rights = rightsArray.find(item => item.editName === editName);
  if (!rights) {
    return {};
  }
  return rights.accessRights;
}
export default {
  getRightsByIndexName,
  getRightsByEditName,
};



// WEBPACK FOOTER //
// ./src/helpers/accessRights.js